import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import snakeCase from "lodash/snakeCase";
var CHAT_SUPPORT_ISO_TO_COUNTRY_NAME = {
  AUS: "Australia",
  AUT: "Austria",
  BEL: "Belgium",
  CAN: "Canada",
  DNK: "Denmark",
  FIN: "Finland",
  FRA: "France",
  DEU: "Germany",
  GRC: "Greece",
  IRL: "Ireland",
  ITA: "Italy",
  LUX: "Luxembourg",
  NLD: "Netherlands",
  NZL: "New Zealand",
  NOR: "Norway",
  PRT: "Portugal",
  ESP: "Spain",
  SWE: "Sweden",
  CHE: "Switzerland",
  GBR: "United Kingdom",
  USA: "United States"
};
// @ts-prune-ignore-next
export var getZenDeskIssueTypeTag = function getZenDeskIssueTypeTag(customerType, issueType) {
  if (customerType === "" || issueType === "") {
    return "";
  }
  return "".concat(customerType.toLowerCase(), "_").concat(issueType.toLowerCase().replace(/-/g, "_"));
};
export var getAllZenDeskTags = function getAllZenDeskTags(countryISO, customerType, issueType) {
  return "".concat(getBasedInZenDeskTag(countryISO), ", ").concat(getZenDeskCustomerTypeTag(customerType), ", ").concat(getZenDeskIssueTypeTag(customerType, issueType));
};
export var getAllZenDeskTagsInArray = function getAllZenDeskTagsInArray(countryISO, customerType, issueType) {
  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }
  return [getBasedInZenDeskTag(countryISO), getZenDeskCustomerTypeTag(customerType), getZenDeskIssueTypeTag(customerType, issueType)].concat(rest);
};
var convertIsoToZenDeskLocationTag = function convertIsoToZenDeskLocationTag(countryISO) {
  if (countryISO === "GBR") {
    return "location_uk";
  }
  return "location_".concat(snakeCase(CHAT_SUPPORT_ISO_TO_COUNTRY_NAME[countryISO]));
};
// @ts-prune-ignore-next
export var getBasedInZenDeskTag = function getBasedInZenDeskTag(countryISO) {
  if (!Object.keys(CHAT_SUPPORT_ISO_TO_COUNTRY_NAME).includes(countryISO)) {
    return "location_other";
  }
  return convertIsoToZenDeskLocationTag(countryISO);
};
var getZenDeskCustomerTypeTag = function getZenDeskCustomerTypeTag(customerType) {
  switch (customerType) {
    case "retailer":
      return "retailer";
    case "brand":
      return "brand";
    default:
      return "retailer";
  }
};